import React from "react";
import PropTypes from "prop-types";
import { PiPlant } from "react-icons/pi";
import { GoGoal } from "react-icons/go";
import classnames from "classnames";
function GoalAvatar(_ref) {
  var size = _ref.size,
    goal = _ref.goal,
    className = _ref.className,
    onClick = _ref.onClick;
  var width, height, borderRadius, iconSize;
  if (size === "xs") {
    width = 25;
    height = 25;
    borderRadius = 3;
    iconSize = 20;
  } else if (size === "sm") {
    width = 33;
    height = 33;
    borderRadius = 6;
    iconSize = 22;
  } else if (size === "md") {
    width = 40;
    height = 40;
    borderRadius = 6;
    iconSize = 24;
  } else if (size === "lg") {
    width = 80;
    height = 80;
    borderRadius = 12;
    iconSize = 48;
  } else if (size === "xl") {
    width = 150;
    height = 150;
    borderRadius = 12;
    iconSize = 64;
  } else {
    throw new Error("Size not supported.");
  }
  return goal.displayablePicture ? /*#__PURE__*/React.createElement("img", {
    width: width,
    height: height,
    src: goal.displayablePicture.src,
    onError: function onError(e) {
      e.target.onerror = null;
      e.target.src = "/img/image_missing.png";
    },
    className: classnames("border", className),
    style: {
      borderRadius: borderRadius,
      objectFit: "cover"
    },
    onClick: onClick
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classnames("d-flex", "justify-content-center", "align-items-center", "bg-gradient-brand-primary-to-pink", className),
    style: {
      width: width,
      height: height,
      borderRadius: borderRadius
    }
  }, goal.id === -1 ? /*#__PURE__*/React.createElement(PiPlant, {
    color: "white",
    size: iconSize
  }) : /*#__PURE__*/React.createElement(GoGoal, {
    color: "white",
    size: iconSize
  })));
}
export default GoalAvatar;
GoalAvatar.defaultProps = {
  size: "md"
};
GoalAvatar.propTypes = {
  size: PropTypes.string,
  goal: PropTypes.object.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};